import { connect } from 'react-redux';
import type { AppState } from 'state/state.model';
import type { ApplyResponse, ApplyStatus } from 'state/tradeAllocationForm';
import * as TradeAllocationSelectors from 'state/tradeAllocationForm/tradeAllocationForm.selector';

interface OwnProps {
  tabId: string;
}

interface StateProps {
  applyResponse?: ApplyResponse;
  applyStatus?: ApplyStatus;
}

export type StatusProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  return {
    applyStatus: TradeAllocationSelectors.getApplyStatus(state, tabId),
    applyResponse: TradeAllocationSelectors.getApplyResponse(state, tabId),
  };
};

export const connectStatus = connect(mapStateToProps);
